import AnimatingDots from '~/components/AnimatingDots';
import Gap from '~/components/Gap';
import PaginationBar from '~/components/PaginationBar';
import Text from '~/components/Text';
import { useIsDesktop } from '~/hooks/useIsDesktop';

import BillingTable from './BillingTable';
import BillingList from './BillingList';
import { useBilling } from './hooks/useBilling';
import { BillingContext } from './hooks/useBillingContext';
import { EmptyBillingContainer } from './styles';

const BillingHistorySection = () => {
  const isDesktop = useIsDesktop();
  const {
    listIds,
    listData,
    isLoading: billingLoading,
    error: billingError,
    currentPage,
    totalPages,
    totalCount,
    fetchSpecificPage,
  } = useBilling();

  if (billingError) {
    return (
      <div>
        <Text size="md" className="bold">
          Billing History
        </Text>
        <Gap t={24} />
        <div style={{ textAlign: 'center', padding: '48px 24px' }}>
          <Text size="md" color="var(--danger)">
            {billingError}
          </Text>
          <Gap t={16} />
          <Text size="sm" color="var(--neut3)">
            Please try refreshing the page or contact support if the problem persists.
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Text size="md" className="bold">
        Billing History
      </Text>
      <Gap t={24} />

      {billingLoading && (
        <div className="full-width center">
          <AnimatingDots />
        </div>
      )}

      {!billingLoading && listIds.length === 0 && (
        <EmptyBillingContainer>
          <Text size="sm" color="var(--neut3)">
            No billing history available yet.
          </Text>
          <Gap t={8} />
          <Text size="xs" color="var(--neut3)">
            Your payment history will appear here once you upgrade to a paid plan.
          </Text>
        </EmptyBillingContainer>
      )}

      {listIds.length > 0 && (
        <BillingContext.Provider value={{ listIds, listData }}>
          <div className="full-width">
            {isDesktop ? <BillingTable /> : <BillingList />}
            <PaginationBar
              totalItems={totalCount}
              totalPages={totalPages}
              itemsPerPage={10}
              currentPage={currentPage}
              onPageChange={fetchSpecificPage}
              onItemsPerPageChange={() => {}}
            />
          </div>
        </BillingContext.Provider>
      )}
    </div>
  );
};

export default BillingHistorySection;
